import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNewspaper2"><Path d="M12 7.5C12 5.84315 10.6569 4.5 9 4.5H1.5V19.5H9C11 19.5 12 20.3431 12 22M12 7.5C12 5.84315 13.3431 4.5 15 4.5H22.5V19.5H15C13 19.5 12 20.3431 12 22M12 7.5V22" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconNewspaper2;
